import React from 'react';
import { ShieldAlert, Lock, ArrowLeft, RefreshCcw } from 'lucide-react';

const UnauthorizedPage = ({ 
  projectName = 'App',
  onGoToDashboard = () => {},
  onSignInDifferent = () => {},
  brandColor = 'slate'
}) => {
  // Color scheme based on brandColor prop
  const colorSchemes = {
    slate: {
      gradient: 'from-slate-900 via-slate-800 to-slate-900',
      button: 'from-slate-800 to-slate-900 hover:from-slate-700 hover:to-slate-800',
      text: 'text-slate-700 hover:text-slate-900',
      lightBg: 'bg-slate-50',
      iconColor: 'text-slate-600',
      accentBg: 'bg-slate-100'
    },
    blue: {
      gradient: 'from-blue-900 via-blue-800 to-blue-900',
      button: 'from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600',
      text: 'text-blue-600 hover:text-blue-800',
      lightBg: 'bg-blue-50',
      iconColor: 'text-blue-600',
      accentBg: 'bg-blue-100'
    },
    green: {
      gradient: 'from-green-900 via-green-800 to-green-900',
      button: 'from-green-600 to-green-700 hover:from-green-500 hover:to-green-600',
      text: 'text-green-600 hover:text-green-800',
      lightBg: 'bg-green-50',
      iconColor: 'text-green-600',
      accentBg: 'bg-green-100'
    },
    purple: {
      gradient: 'from-purple-900 via-purple-800 to-purple-900',
      button: 'from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600',
      text: 'text-purple-600 hover:text-purple-800',
      lightBg: 'bg-purple-50',
      iconColor: 'text-purple-600',
      accentBg: 'bg-purple-100'
    }
  };

  const colors = colorSchemes[brandColor] || colorSchemes.slate;

  return (
    <div className={`min-h-screen bg-gradient-to-br ${colors.gradient} flex items-center justify-center p-4`}>
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-block bg-white p-4 rounded-2xl shadow-lg mb-4">
            <div className="text-4xl font-bold text-gray-900">{projectName}</div>
          </div>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-red-100 rounded-full p-6">
              <ShieldAlert className="w-12 h-12 text-red-600" />
            </div>
          </div>

          {/* Title & Message */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Access Not Authorized
            </h2>
            <p className="text-gray-600 mb-2">
              You don't have permission to access <span className="font-semibold text-gray-900">{projectName}</span>.
            </p>
            <p className="text-sm text-gray-500">
              Please request access from the project administrator or contact support.
            </p>
          </div>



          {/* What You Can Do */}
          <div className={`${colors.lightBg} rounded-xl p-4 mb-6 border border-gray-100`}>
            <h3 className="font-semibold text-gray-900 mb-3 text-sm">How to get access:</h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <span className={`w-1.5 h-1.5 ${colors.accentBg} rounded-full mt-2 flex-shrink-0`}></span>
                <span>Contact the project administrator to request access</span>
              </li>
              <li className="flex items-start gap-2">
                <span className={`w-1.5 h-1.5 ${colors.accentBg} rounded-full mt-2 flex-shrink-0`}></span>
                <span>The administrator will add you to the project</span>
              </li>
              <li className="flex items-start gap-2">
                <span className={`w-1.5 h-1.5 ${colors.accentBg} rounded-full mt-2 flex-shrink-0`}></span>
                <span>You'll receive a notification once access is granted</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={onGoToDashboard}
              className={`w-full bg-gradient-to-r ${colors.button} text-white py-4 px-6 rounded-xl font-semibold shadow-lg transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2`}
            >
              Reload Dashboard
                            <RefreshCcw className="w-5 h-5" />

            </button>

            <button
              onClick={onSignInDifferent}
              className={`w-full text-center py-2 ${colors.text} font-medium text-sm transition-colors flex items-center justify-center gap-2`}
            >
              <Lock className="w-4 h-4" />
              Sign In with Different Account
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-400">
            Need help? Contact your administrator
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;